import { createIcon } from './create-icon'

export const Attachment = createIcon({
  displayName: 'Attachment',
  paths: [
    'M512 938.667c-164.693 0-298.667-133.973-298.667-298.667v-298.667c0-23.552 19.115-42.667 42.667-42.667s42.667 19.115 42.667 42.667v298.667c0 117.632 95.701 213.333 213.333 213.333s213.333-95.701 213.333-213.333v-341.333c0-70.571-57.429-128-128-128s-128 57.429-128 128v358.4c0 23.509 19.157 42.667 42.667 42.667s42.667-19.157 42.667-42.667v-315.733c0-23.552 19.115-42.667 42.667-42.667s42.667 19.115 42.667 42.667v315.733c0 70.571-57.429 128-128 128s-128-57.429-128-128v-358.4c0-117.632 95.701-213.333 213.333-213.333s213.333 95.701 213.333 213.333v341.333c0 164.693-133.973 298.667-298.667 298.667z'
  ]
})
